import { useTranslate } from "@tolgee/react";
import { useMemo } from "react";
import { InvoiceStatus } from "../../../clients/graphqlTypes.js";

const ALL_OUTGOING_STATUS: InvoiceStatus[] = [
  "draft",
  "open",
  "cancelled",
  "paid",
];
export type IncomingInvoiceStatus = "open" | "paid";
const ALL_INCOMING_STATUS: IncomingInvoiceStatus[] = ["open", "paid"];

export function useInvoiceStatus() {
  const { t } = useTranslate(["ProjectOverview"]);

  const outgoingStatusLabels: Record<InvoiceStatus, string> = useMemo(
    () => ({
      draft: t("Draft"),
      open: t("Open"),
      cancelled: t("Cancelled"),
      paid: t("Paid"),
    }),
    [t]
  );
  const incomingStatusLabels: Record<IncomingInvoiceStatus, string> = useMemo(
    () => ({
      open: t("Open"),
      paid: t("Paid"),
    }),
    [t]
  );

  const outgoingStatusOptions = useMemo(
    () =>
      ALL_OUTGOING_STATUS.map(status => ({
        value: status,
        label: outgoingStatusLabels[status],
      })),
    [outgoingStatusLabels]
  );
  const incomingStatusOptions = useMemo(
    () =>
      ALL_INCOMING_STATUS.map(status => ({
        value: status,
        label: incomingStatusLabels[status],
      })),
    [incomingStatusLabels]
  );

  return {
    outgoingStatusLabels,
    incomingStatusLabels,
    outgoingStatusOptions,
    incomingStatusOptions,
  };
}
